import { useEffect, useState } from "react";
import ClientAdSettingsContent from "@components/Advertisement/components/ClientAdSettings/ClientAdSettingsContent";
import AdvertisementOverlay from "@features/advertisement/components/AdvertisementOverlay";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import { useGetPosthogVariant } from "@features/posthog/hooks/useGetPosthogVariant";
import { FEATURE_FLAG_DEEPERDIVE_AB_TEST } from "@features/posthog/utils/constants";

const ClientAdSettingsClientData = (): React.ReactElement => {
  const { isAuthenticated, userType } = useUserInfo();
  const [isClientDataInjected, setIsClientDataInjected] = useState(false);
  const { gaVariant } = useGetPosthogVariant({
    flag: FEATURE_FLAG_DEEPERDIVE_AB_TEST,
    isEnabledFeatureFlagVariant: true,
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const windowBtPageData = window.bt_page_data;
    const isABTestEnabled = windowBtPageData?.isABTestEnabled;

    if (gaVariant === undefined && isABTestEnabled) return;

    console.log("[ClientAdSettingsData] useEffect called"); // eslint-disable-line no-console

    window.bt_page_data = {
      ...window.bt_page_data,
      userInfo: isAuthenticated ? { usertype: userType } : null,
      adTargets: [
        ...window.bt_page_data.adTargets,
        { ...(isABTestEnabled ? { key: "abVariant", value: gaVariant } : {}) },
      ],
    };

    setIsClientDataInjected(true);
  }, [isAuthenticated, userType, gaVariant]);

  if (!isClientDataInjected) {
    return (
      <AdvertisementOverlay className="h-100vh w-100vw fixed inset-0 left-0 top-0 z-[1000001] overflow-y-hidden bg-white" />
    );
  }

  return <ClientAdSettingsContent />;
};

export default ClientAdSettingsClientData;
